import React from 'react';
import Image from 'react-bootstrap/Image';
import { ReactSVG } from 'react-svg';

export default (props) => {
  // Compulsory to pass isSA as a props when using in SA side
  let IconComponent = require(`../../images/${props.name}`).default;

  return props.isSA ? (
    <IconComponent className={props.className} {...props} />
  ) : props.name ? (
    <Image src={require(`../../images/${props.name}`)} {...props} />
  ) : (
    <Image {...props} />
  );
};
